export const AiDifficulty = {
    Easy: 0,
    Medium: 1,
    Hard: 2,
};